import apiClient from "./client";
import type { IconMutationResponse } from "../types/icon";

type UpdateIconOptions = {
  id?: number;
};

export const createIcon = async (
  formData: FormData
): Promise<IconMutationResponse> => {
  const { data } = await apiClient.post<IconMutationResponse>(
    "/icon",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return data;
};

export const updateIcon = async (
  formData: FormData,
  options: UpdateIconOptions = {}
): Promise<IconMutationResponse> => {
  const config: {
    headers: { "Content-Type": string };
    params?: { id: number };
  } = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  if (options.id) {
    config.params = { id: options.id };
  }
  const { data } = await apiClient.put<IconMutationResponse>(
    "/icon",
    formData,
    config
  );
  return data;
};

export const deleteIcon = async (
  iconId: number | string
): Promise<IconMutationResponse> => {
  const { data } = await apiClient.delete<IconMutationResponse>(
    `/icon/${iconId}`
  );
  return data;
};
